export const productCategories = [
  {
    id: 'skincare',
    name: '呦呦·护肤',
    nameEn: 'Skincare',
    description: '源自天然植物的护肤智慧，以东方草本精粹唤醒肌肤原生之美。',
    imageSeq: 'youyou-skincare',
    products: [
      { id: 1, name: '呦呦·清露精华液', desc: '蕴含芍药与白芷精华，深层滋润修复', price: '¥398', imageSeq: 'skincare-01' },
      { id: 2, name: '呦呦·凝脂面霜', desc: '以《诗经》草木为引，打造柔嫩丝滑肤感', price: '¥458', imageSeq: 'skincare-02' },
      { id: 3, name: '呦呦·芳草洁面乳', desc: '温和洁净不紧绷，氨基酸配方呵护', price: '¥268', imageSeq: 'skincare-03' },
      { id: 4, name: '呦呦·花间面膜', desc: '花瓣纤维膜布，一片焕亮水润光泽', price: '¥328', imageSeq: 'skincare-04' },
      { id: 5, name: '呦呦·玉容防晒乳', desc: '轻薄透气防晒，以草本之力抵御光老化', price: '¥298', imageSeq: 'skincare-05' },
      { id: 6, name: '呦呦·凝时眼霜', desc: '焕亮眼周，淡化细纹，重现神采眼眸', price: '¥388', imageSeq: 'skincare-06' },
    ],
  },
  {
    id: 'fragrance',
    name: '呦呦·香氛',
    nameEn: 'Fragrance',
    description: '以《诗经》意象入香，每一缕芬芳都是一段千年诗韵。',
    imageSeq: 'youyou-fragrance',
    products: [
      { id: 7, name: '呦呦·鹿鸣香薰', desc: '草木清韵，如呦呦鹿鸣般悠远空灵', price: '¥568', imageSeq: 'fragrance-01' },
      { id: 8, name: '呦呦·蒹葭蜡烛', desc: '水边芦苇的清香，再现蒹葭苍苍的意境', price: '¥328', imageSeq: 'fragrance-02' },
      { id: 9, name: '呦呦·桃夭香氛', desc: '桃花灼灼的明媚芬芳，散发春日浪漫气息', price: '¥428', imageSeq: 'fragrance-03' },
      { id: 10, name: '呦呦·关雎香囊', desc: '古典香囊设计，随身携带的东方雅韵', price: '¥188', imageSeq: 'fragrance-04' },
      { id: 11, name: '呦呦·采薇线香', desc: '天然植物线香，营造禅意空间氛围', price: '¥258', imageSeq: 'fragrance-05' },
      { id: 12, name: '呦呦·淇奥香挂', desc: '衣橱香挂，让衣物散发淡淡草木清香', price: '¥168', imageSeq: 'fragrance-06' },
    ],
  },
  {
    id: 'tea',
    name: '呦呦·茶品',
    nameEn: 'Tea',
    description: '精选高山原叶，以传统工艺制茶，在一盏清茗中品味自然。',
    imageSeq: 'youyou-tea',
    products: [
      { id: 13, name: '呦呦·南山白茶', desc: '高山有机白茶，清甜回甘如诗如画', price: '¥328', imageSeq: 'tea-01' },
      { id: 14, name: '呦呦·幽谷乌龙', desc: '半发酵乌龙，花香馥郁层次丰富', price: '¥368', imageSeq: 'tea-02' },
      { id: 15, name: '呦呦·春涧绿茶', desc: '明前嫩芽，鲜爽甘醇一口入春', price: '¥258', imageSeq: 'tea-03' },
      { id: 16, name: '呦呦·山月红茶', desc: '全发酵红茶，温润醇厚暖入心脾', price: '¥298', imageSeq: 'tea-04' },
      { id: 17, name: '呦呦·松风普洱', desc: '古树普洱生茶，岁月陈香回味悠长', price: '¥528', imageSeq: 'tea-05' },
      { id: 18, name: '呦呦·菊篱花茶', desc: '杭白菊配枸杞，清肝明目养生之选', price: '¥188', imageSeq: 'tea-06' },
    ],
  },
  {
    id: 'home',
    name: '呦呦·家居',
    nameEn: 'Home',
    description: '将东方意境融入日常生活，每一件器物都是可以触摸的诗。',
    imageSeq: 'youyou-home',
    products: [
      { id: 19, name: '呦呦·幽兰茶具', desc: '手工陶瓷茶具，简约雅致禅意十足', price: '¥698', imageSeq: 'home-01' },
      { id: 20, name: '呦呦·清风竹编', desc: '手工编织竹器，自然材质生活美学', price: '¥238', imageSeq: 'home-02' },
      { id: 21, name: '呦呦·墨韵文房', desc: '文房四宝套装，书写东方雅致生活', price: '¥528', imageSeq: 'home-03' },
      { id: 22, name: '呦呦·素笺笔记本', desc: '手工宣纸内页，记录生活诗意瞬间', price: '¥128', imageSeq: 'home-04' },
      { id: 23, name: '呦呦·云锦抱枕', desc: '传统织锦工艺，为居室增添东方韵味', price: '¥368', imageSeq: 'home-05' },
      { id: 24, name: '呦呦·月色香炉', desc: '纯铜手工香炉，品香悟道雅趣天成', price: '¥458', imageSeq: 'home-06' },
    ],
  },
];

export const allProducts = productCategories.flatMap(cat => cat.products);